/* The "Reserveret i mm:ss" line in the cart drawer.
   Cosmetic on purpose: it counts down and then hides itself — it never empties the cart.
   The deadline lives in sessionStorage so it survives the drawer re-rendering itself, and it
   starts over whenever the cart changes. One document-level ticker, because the theme
   replaces the drawer's markup on every cart update. */
(() => {
  const KEY = 'cc:cart:reserved-until';
  const store = (() => {
    try {
      window.sessionStorage.setItem(KEY + ':t', '1');
      window.sessionStorage.removeItem(KEY + ':t');
      return window.sessionStorage;
    } catch (e) {
      return null; // private mode, blocked storage: fall back to the page's lifetime
    }
  })();
  let fallback = 0;

  const readDeadline = () => Number((store ? store.getItem(KEY) : fallback) || 0);
  const writeDeadline = (value) => {
    if (store) store.setItem(KEY, String(value));
    else fallback = value;
  };

  const cartHasItems = () => !!document.querySelector('.cart-drawer cart-items .cart-item');

  const start = (minutes) => {
    writeDeadline(Date.now() + minutes * 60000);
  };

  const tick = () => {
    const el = document.querySelector('.cart-drawer [data-cc-timer]');
    if (!el) return;

    if (!cartHasItems()) {
      el.hidden = true;
      writeDeadline(0);
      return;
    }

    const minutes = Number(el.dataset.ccMinutes) || 10;
    let deadline = readDeadline();
    if (!deadline) {
      start(minutes);
      deadline = readDeadline();
    }

    const left = Math.round((deadline - Date.now()) / 1000);
    if (left <= 0) {
      el.hidden = true;
      return;
    }

    const clock = el.querySelector('[data-cc-clock]');
    const text = `${String(Math.floor(left / 60)).padStart(2, '0')}:${String(left % 60).padStart(2, '0')}`;
    if (clock && clock.textContent !== text) clock.textContent = text;
    el.hidden = false;
  };

  // adding or removing a line gives the shopper the full window again
  document.addEventListener('cart:updated', () => {
    const el = document.querySelector('.cart-drawer [data-cc-timer]');
    start(Number(el?.dataset.ccMinutes) || 10);
    tick();
  });

  const boot = () => {
    tick();
    window.setInterval(tick, 1000);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
